import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { TextVariants, ArtDirectedImage, ImgixImage, ImgIXRatio, Colors } from "../../index";
export const processCropRatios = (sb = "tower_block_left", ratio = ImgIXRatio("none")) => {
    switch (sb) {
        case "tower_block_left":
            return [
                ImgIXRatio("16:9"),
                ImgIXRatio("16:9"),
                ImgIXRatio("16:9"),
                ImgIXRatio("3:4")
            ];
        case "tower_block_right":
            return [
                ImgIXRatio("16:9"),
                ImgIXRatio("3:4"),
                ImgIXRatio("16:9"),
                ImgIXRatio("16:9")
            ];
        case "asymmetric_left":
            return [
                ImgIXRatio("3:4"),
                ImgIXRatio("1:1"),
                ImgIXRatio("1:1"),
                ImgIXRatio("3:4")
            ];
        case "asymmetric_right":
            return [
                ImgIXRatio("1:1"),
                ImgIXRatio("3:4"),
                ImgIXRatio("3:4"),
                ImgIXRatio("1:1")
            ];
        case "split_left":
            return [ImgIXRatio("16:9"), ImgIXRatio("3:4")];
        case "split_right":
            return [ImgIXRatio("3:4"), ImgIXRatio("16:9")];
        case "double":
            return ratio; //get ratio from data prop
        case "triple":
            return ratio; //get ratio from data prop
        case "quad":
            return ratio; //get ratio from data prop
        default:
            return ImgIXRatio("16:9");
    }
};
export const Window = ({ items, onImageClick, window_variant = "tower_block_left", caption, ratio = ImgIXRatio("none") }) => {
    const gridSpacing = [24, 24, 32, 48, 56];
    const windowStylesAsymmetricLeft = {
        display: "grid",
        gridGap: gridSpacing,
        gridTemplateColumns: "repeat(12, [col-start] 1fr)",
        "& div": {
            height: "100%"
        },
        ".item-0": {
            gridColumn: "col-start / span 6",
            gridRow: "1 / 3"
        },
        ".item-1": {
            gridColumn: " 7 / span 6",
            gridRow: "1 / 1"
        },
        ".item-2": {
            gridColumn: "col-start / span 6",
            gridRow: "3 / 4"
        },
        ".item-3": {
            gridColumn: "7 / span 6",
            gridRow: "2 / 4"
        }
    };
    const windowStylesAsymmetricRight = {
        display: "grid",
        gridGap: gridSpacing,
        gridTemplateColumns: "repeat(12, [col-start] 1fr)",
        "& div": {
            height: "100%"
        },
        ".item-0": {
            gridColumn: "col-start / span 6",
            gridRow: "1 / 1"
        },
        ".item-1": {
            gridColumn: " 7 / span 6",
            gridRow: "1 / 3"
        },
        ".item-2": {
            gridColumn: "col-start / span 6",
            gridRow: "2 / 4"
        },
        ".item-3": {
            gridColumn: "7 / span 6",
            gridRow: "3 / 4"
        }
    };
    const windowStylesTowerLeft = {
        display: "grid",
        gridGap: gridSpacing,
        gridTemplateColumns: "repeat(12, [col-start] 1fr)",
        div: {
            height: "100%"
        },
        ".item-0": {
            gridColumn: "col-start / span 12",
            gridRow: "1 / 3"
        },
        ".item-1": {
            gridColumn: " col-start / span 6",
            gridRow: "3 "
        },
        ".item-2": {
            gridColumn: "col-start / span 6",
            gridRow: "4"
        },
        ".item-3": {
            gridColumn: "7 / span 6",
            gridRow: "3 / 5"
        }
    };
    const windowStylesTowerRight = {
        display: "grid",
        gridGap: gridSpacing,
        gridTemplateColumns: "repeat(12, [col-start] 1fr)",
        div: {
            height: "100%"
        },
        ".item-0": {
            gridColumn: "col-start / span 12",
            gridRow: "1 / 3"
        },
        ".item-1": {
            gridColumn: "1 / span 6",
            gridRow: "3 / 5"
        },
        ".item-2": {
            gridColumn: "7 / span 6",
            gridRow: "3"
        },
        ".item-3": {
            gridColumn: "7 / span 6",
            gridRow: "4"
        }
    };
    const windowStylesSplitLeft = {
        display: "grid",
        gridGap: gridSpacing,
        gridTemplateColumns: "repeat(12, [col-start] 1fr)",
        div: {
            height: "100%"
        },
        ".item-0": {
            gridColumn: "col-start / span 8"
        },
        ".item-1": {
            gridColumn: "9 / span 5"
        }
    };
    const windowStylesSplitRight = {
        display: "grid",
        gridGap: gridSpacing,
        gridTemplateColumns: "repeat(12, [col-start] 1fr)",
        div: {
            height: "100%"
        },
        ".item-0": {
            gridColumn: "col-start / span 4"
        },
        ".item-1": {
            gridColumn: "5 / span 8"
        }
    };
    const windowStylesDouble = {
        display: "grid",
        gridGap: gridSpacing,
        gridTemplateColumns: "repeat(2,1fr)"
    };
    const windowStylesTriple = {
        display: "grid",
        gridGap: gridSpacing,
        gridTemplateColumns: "repeat(3,1fr)"
    };
    const windowStylesQuad = {
        display: "grid",
        gridGap: gridSpacing,
        gridTemplateColumns: "repeat(4,1fr)"
    };
    const processAlignment = (sb) => {
        switch (sb) {
            case "tower_block_left":
                return windowStylesTowerLeft;
            case "tower_block_right":
                return windowStylesTowerRight;
            case "asymmetric_left":
                return windowStylesAsymmetricLeft;
            case "asymmetric_right":
                return windowStylesAsymmetricRight;
            case "split_left":
                return windowStylesSplitLeft;
            case "split_right":
                return windowStylesSplitRight;
            case "double":
                return windowStylesDouble;
            case "triple":
                return windowStylesTriple;
            case "quad":
                return windowStylesQuad;
            default:
                return windowStylesTowerLeft;
        }
    };
    const processSize = (sb) => {
        switch (sb) {
            case "tower_block_left":
                return ["60vw", "40vw", "40vw", "40vw"];
            case "tower_block_right":
                return ["60vw", "40vw", "40vw", "40vw"];
            case "asymmetric_left":
                return ["40vw", "40vw", "40vw", "40vw"];
            case "asymmetric_right":
                return ["40vw", "40vw", "40vw", "40vw"];
            case "split_left":
                return ["50vw", "30vw"];
            case "split_right":
                return ["30vw", "50vw"];
            case "double":
                return ["40vw", "40vw"];
            case "triple":
                return ["25vw", "25vw", "25vw"];
            case "quad":
                return ["15vw", "15vw", "15vw", "15vw"];
            default:
                return "25vw";
        }
    };
    const ratioArray = processCropRatios(window_variant, ratio);
    return (_jsxs(Box, { sx: { width: "100%" }, className: window_variant, children: [_jsx(Flex, { sx: Object.assign({ width: "100%" }, processAlignment(window_variant)), children: items === null || items === void 0 ? void 0 : items.map((item, idx) => {
                    // width={item.dimensions.width || 400}
                    // height={item.dimensions.height || 400}
                    const imageRatio = typeof ratioArray === "object" ? ratioArray[idx] : ratioArray;
                    return (_jsx(Box, { className: `item-${idx}`, onClick: () => onImageClick && onImageClick(idx), tabIndex: onImageClick ? 0 : undefined, onKeyPress: k => k.key === "Enter" ? onImageClick && onImageClick(idx) : null, sx: { width: "100%" }, children: _jsx(ArtDirectedImage, { sx: {
                                cursor: !!onImageClick ? "pointer" : "default"
                            }, noRatio: true, hlsVideoURL: item.imgix_video, imageNode: _jsx(ImgixImage, { imageUrl: item.url, imageAlt: item.alt, aspectRatio: imageRatio, sizes: processSize(window_variant)[idx] }), imageAlt: item.alt || "" }) }, `window-item-${idx}`));
                }) }), caption && (_jsx(Box, { sx: { display: "block" }, children: _jsx("div", { sx: {
                        variant: `text.${TextVariants.technicalParagraphSmall}`,
                        mt: 16,
                        color: Colors.grey[1],
                        maxWidth: "48ch"
                    }, children: caption }) }))] }));
};
//# sourceMappingURL=Window.js.map